import type React from "react";

const PomodoroTimerPage: React.FC = () => {
	return (
		<div className="space-y-6">
			<h1 className="text-3xl font-bold">ポモドーロタイマー</h1>
			<div className="bg-white p-6 rounded-lg shadow">
				{/* ポモドーロタイマーコンポーネントをここに配置 */}
			</div>
		</div>
	);
};

export default PomodoroTimerPage;
